module.exports = __webpack_public_path__ + "img/msg04.499bac22.png";